<panel width="300">
    @if (legalCases) {
        <list-view>
            <header [defaultSort]="'descending'">{{ 'company.legal-case.created-date' | translate }}</header>
            <header></header>
            <row *listData="let legalCase from legalCases" [highlighted]="legalCase == selectedLegalCase" [brand]="legalCase.brandId" (action)="selectedLegalCase = legalCase">
                <column [sortValue]="legalCase.created">{{ legalCase.created | customDate: 'shortDate' }}</column>
                <column align-right>{{ legalCase.status == LegalCaseStatus.Closed ? ('company.legal-case.closed' | translate) : '' }}</column>
            </row>
        </list-view>
    }
    @else { <skeletons [defaultSkeletons]="2" /> }
</panel>
<panel>
    <h1>{{ 'company.legal-case.debt-collection-details.header' | translate }}</h1>
    @if (selectedLegalCase) {
        <edit-legal-case [legalCase]="selectedLegalCase" (close)="close()" />
    }
    @else {
        <section>{{ 'company.legal-case.none-selected' | translate }}</section>
    }
</panel>
@if (company) {
    <panel width="420">
        <h1>{{ company.name }}</h1>
        <company-information [company]="company" />
        <list-contact [company]="company" />
    </panel>
}
